import { BillingCurrentPlanType, BillingSubscriptionType, Maybe, ValueOf } from '@/types/sharedTypes';
import { OPCO_USER_ROLES, OPCO_USER_STATUSES } from '../_OpcoUsersPage/const/const';
import { OrgAdminRoleType, OrganizationUserStatusType } from '@/const/user';
import { InvitationDataType } from '@/types/wireTypes';
import { SubscriptionPlanType } from '@/const/shared';

export const ORGANIZATION_STATUS = {
  ACTIVE: 'active',
  BLOCKED: 'blocked',
} as const;

export type OrganizationStatusType = ValueOf<typeof ORGANIZATION_STATUS>;

export type OrganizationType = {
  id: string;
  name: string;
  subscription_plan_type: SubscriptionPlanType;
  status: OrganizationStatusType;
  is_kyc_allowed: boolean;
  is_api_keys_allowed: boolean;
  date_created: string;
  date_modified?: string;
  active_users_count: number;
  billing_profile: {
    current_plan: Pick<BillingCurrentPlanType, 'billing_frequency' | 'id' | 'max_users' | 'name'>;
    subscription: BillingSubscriptionType;
  };
};

export type OrganizationEditType = {
  name?: string;
  is_kyc_allowed?: boolean;
  is_api_keys_allowed?: boolean;
  subscription_plan_type?: SubscriptionPlanType;
  status?: OrganizationStatusType;
};

export type OpcoUserStatusType = ValueOf<typeof OPCO_USER_STATUSES>;

export type OpcoUserRoleType = ValueOf<typeof OPCO_USER_ROLES>;

export type OrganizationUserType = {
  id: string;
  email: string;
  first_name: string;
  middle_name?: string;
  last_name: string;
  mobile_phone: string;
  role: OrgAdminRoleType | null;
  status: OrganizationUserStatusType;
  last_login: string;
  invitation_data?: InvitationDataType;
};

export type LastResetDetailsType = {
  last_reset: string;
  reset_by: string;
};

export type OpcoUserType = {
  id: string;
  role: OpcoUserRoleType;
  user: {
    id: string;
    mobile_phone: string;
    email: string;
    status: OpcoUserStatusType;
    first_name?: string;
    last_login?: string;
    last_name?: string;
    last_reset_details: Maybe<LastResetDetailsType>;
    middle_name?: string;
  };
};
